<div
  class="form-check"
  [ngClass]="{ 'form-check-inline': inline }"
  [formGroup]="group"
>
  <input
    class="form-check-input"
    type="checkbox"
    [attr.id]="id"
    [value]="value"
    [formControlName]="controlName"
    ds365IsInvalid
  />
  <label class="form-check-label" [attr.for]="id">
    <ng-content></ng-content>
  </label>
</div>